<template>
    <v-container fluid class="pa-0 pa-md-3">
        <v-card class="elevation-0">
            <QDataTableHeader id="lead_datatable">
                <template #left>
                    <div id="q-pending-policy-step-3">
                        <div class="d-flex align-center">
                            <p class="q-display-3 d-flex align-center mb-0">
                                <span>{{ title }}</span>
                                <v-btn class="ml-1" icon dark @click="refreshData">
                                    <v-icon small>fas fa-sync-alt</v-icon>
                                </v-btn>
                            </p>
                            <v-switch color="on-primary" class="ml-8 mt-0 pt-0" hide-details v-model="personal_only" inset :label="personal_only ? 'Personal Production' : 'Total Agency'" @change="refreshData" />
                        </div>
                        <p class="pt-0 mb-0">
                            <v-btn text small color="on-primary" :disabled="!available_filters" @click="toggleFilters">
                                <v-icon small left>fas fa-filter</v-icon> Filter Policies
                            </v-btn>
                        </p>
                    </div>
                </template>
            </QDataTableHeader>

            <v-row class="flex-nowrap" :class="isMobileTableView && 'flex-wrap-reverse'">
                <div class="policy-tables__col-left">
                    <div v-if="response_data.length > 0" class="py-3 px-6">
                        <v-btn text small color="q_leads_4" @click="downloadCsvData">
                            <v-icon small left>fas fa-file-export</v-icon> Export Results
                        </v-btn>
                    </div>

                    <v-data-table
                        v-model="selected"
                        :items="all_data"
                        :headers="allHeaders"
                        :items-per-page.sync="rows"
                        :options.sync="options"
                        :server-items-length="total_server_items"
                        item-key="id"
                        :footer-props="{ itemsPerPageOptions: [10,25,50,100] }"
                        :loading="data_loading"
                        :mobile-breakpoint="0"
                        class="elevation-0 mt-3"
                        @current-items="updateCurrentItems"
                    >
                        <template v-slot:item.PlacedDate="{item}">
                            <span class="nowrap">{{ formatDate(item.PlacedDate) }}</span>
                        </template>
                        <template v-slot:item.AnnualPremium="{item}">
                            <span class="pl-4">{{ formatCurrency(item.AnnualPremium) }}</span>
                        </template>
                        <template v-slot:item.FaceAmount="{item}">
                            <span class="pl-4">{{ formatCurrency(item.FaceAmount) }}</span>
                        </template>
                        <template v-slot:item.Product="{item}">
                            <span>{{ displayProductName(item) }}</span>
                        </template>
                        <template v-slot:item.AgentName="{item}">
                            <router-link v-if="item.AgentCode" class="q_leads_4--text" :to="'/agents/' + item.AgentCode">{{ item.AgentName }}</router-link>
                            <span v-else>{{ item.AgentName }}</span>
                        </template>
                    </v-data-table>
                </div>

                <v-col v-show="available_filters" cols="12" md="auto" :style="filtersStyle">
                    <div
                        class="policy-tables__side"
                        :class="isMobileTableView && 'd-flex flex-column align-end'"
                        :style="isMobileTableView ? {} : { maxWidth: '18rem' }"
                    >
                        <QFilters
                            ref="filters"
                            v-model="filters"
                            :available-filters="available_filters"
                            :keys="filter_keys"
                            dark hide-button column
                        />
                    </div>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
import QDataTableMixin from "./QDataTableMixin.js"
import QuilityAPI from '@/store/API/QuilityAPI.js'
import { debounce } from 'vue-debounce'
import QDataTableHeader from '../datatables/base/QDataTableHeader.vue'
import QScoreCardFilters from '@/components/stats/scorecards/QScoreCardFilters.vue';
import moment from 'moment'

export default {
    name: "QPlacedPolicyDataTable",
    mixins: [QDataTableMixin],
    props: ['agent', 'for_baseshop', 'statType', 'startDate', 'endDate'],
    data () {
        // const currentDate = moment()
        // let month
        // let year
        // // if the day is after the 10th than placed stats should be ready for previous month. 
        // // else go back 2 months to get placed stats. 
        // if (parseInt(currentDate.format('DD')) >= 10){
        //     month = parseInt(currentDate.subtract(1, 'month').format('M'))
        //     year = parseInt(currentDate.subtract(1, 'month').format('YYYY'))
        // } else {
        //     month = parseInt(currentDate.subtract(2, 'month').format('M'))
        //     year = parseInt(currentDate.subtract(2, 'month').format('YYYY'))
        // }
        // if (this.endDate) {
        //     const date = moment(this.endDate)
        //     month = parseInt(date.format('M'))
        //     year = parseInt(date.format('YYYY'))
        // }
        return {
            data_loading: false,
            count_loading: false,
            pending_policy_detail: false,
            is_exporting: false,
            firstPull: true, // this keeps the auto scrolling on data reloads from happening on the first load.
            response_data: [],
            total_server_items: 0,
            current_policy: null,
            server_available_filters: null,
            unique_status_count: null, // holds the counts for each distinct status reason associated with the pending policies
            carrier_info: [], // holds the info about each of the carriers, if the agent has a writing number with them then ShowLogin will be true and the login button will be visable
            options: { sortBy: ['PlacedDate'], sortDesc: ["true"] },
            unique_policy_count: null, // holds the count for each policy status associated with the penind polices
            the_data: [],
            filters: {
                Carrier: "-All-",
                Product: "-All-",
                TimePeriod: {
                    startDate: this.startDate || null,
                    endDate: this.endDate || null,
                },
            },
            personal_only: this.statType == 'PersonalProduction'
        }
    },
    created() {
        this.showFilters = this.showFiltersImmediately
    },
    mounted: function() {
        this.refreshData();
    },
    computed: {
        showFiltersImmediately() {
            return !!(this.startDate || this.endDate || this.statType)
        },
        isMobileTableView () {
			return this.$vuetify.breakpoint.smAndDown
		},
        filtersStyle () {
            return this.showFilters
                ? {}
                : { position: 'absolute', pointerEvents: 'none', opacity: 0, zIndex: -1 }
        },
        filter_keys: function() {
            // these should match up with the keys for the model on the server side - availableFilters
            return ['Carrier', 'Product', 'TimePeriod']
        },
        all_data: function() {
            //instead of using a state/model on the frontend the data is all contained in this module.
            //this computed propery is required by the QDataTableMixin
            return this.response_data
        },

        allHeaders() {
            return [{
                    text: 'Placed Date',
                    value: 'PlacedDate',
                    align: 'start',
                    sortable: true,
                    filterable: true
                },
                {
                    text: 'Agent',
                    value: 'AgentName',
                    align: 'start',
                    sortable: true,
                    filterable: false
                },
                {
                    text: 'Client',
                    value: 'InsuredName',
                    align: 'start',
                    sortable: true,
                    filterable: false
                },
                {
                    text: 'Face Amount',
                    value: 'FaceAmount',
                    align: 'right',
                    sortable: true,
                    filterable: false,
                    class: 'header-class',
                },
                {
                    text: 'Annual Premium',
                    value: 'AnnualPremium',
                    align: 'start',
                    sortable: true,
                    filterable: false,
                    class: 'header-class',
                },
                {
                    text: 'Carrier',
                    value: 'Carrier',
                    align: 'start',
                    sortable: true,
                    filterable: true,
                    class: 'header-class',
                },
                {
                    text: 'Product',
                    value: 'Product',
                    align: 'start',
                    sortable: true,
                    filterable: true
                },
                {
                    text: 'Status',
                    value: 'PolicyStatus',
                    align: 'start',
                    sortable: true,
                    filterable: true
                },
                {
                    text: 'Policy #',
                    value: 'PolicyNumber',
                    align: 'start',
                    sortable: true,
                    filterable: true
                }
            ]
        },

        //server_available_filters will be set by our first data pull where the server responds with all data for the filter drop downs.
        //QDataTableMixin requires this computed property.
        'available_filters': function() {
            return this.server_available_filters
        },
        is_loading: function() {
            return this.count_loading || this.data_loading
        }
    },
    methods: {
        //get called by the QDataTableMixin whenever we need to refresh the data from the server.
        loadData: debounce(function(opt) {
            this.data_loading = true
            this.filters.AgentName = this.agent.AgentName
            const { TimePeriod, ...filters } = this.filters
            QuilityAPI.getAgentPolicies(this.agent.AgentCode, 'placed', { ...filters, ...TimePeriod, personal_only: this.personal_only }, opt)
                .then((json) => {
                    if (this.is_exporting) {
                        const fileURL = window.URL.createObjectURL(new Blob([json]))
                        const fileLink = document.createElement('a')
                        fileLink.href = fileURL
                        fileLink.setAttribute('download', 'placed-policy-data.csv')
                        document.body.appendChild(fileLink)
                        fileLink.click()
                    } else {
                        this.response_data = json.data
                        this.total_server_items = json.meta?.total // lets the data table know how many results the full set is from the server
                        if (json.meta?.filters) {
                            this.server_available_filters = json.meta.filters
                        }
                    }
                    this.data_loading = false
                    this.is_exporting = false
                })
                .catch((err) => {
                    console.error(err)
                    this.showError('There was an issue with loading data.<br>', err.message)
                    this.data_loading = false
                })
            this.firstPull = false
        }, 200),
        displayProductName(item) {
            return item.ProductName ? item.ProductName : item.Product
        },
        exportResults: function() {
            this.is_exporting = true
            this.refreshData();
        },
        downloadCsvData: debounce(function() {
            const { TimePeriod, ...filters } = this.filters
            const endpoint = `/api/private/policies/placed/agent/${this.agent.AgentCode}`
            const params = {
                ...this.options,
                ...filters,
                ...TimePeriod,
                personal_only: this.personal_only,
                itemsPerPage: 'csv',
                attr: '',
            }
            this.dispatchJob({
                method: 'GET',
                path: endpoint,
                params: params,
                JobName: 'Placed Policies Export',
            })
        }, 200),
        changeAgent: function() {

        }
    },
    watch: {
        'agent.AgentCode': function() {
            this.$nextTick(this.refreshData) // this is the QDataTableMixin call that does stuff needed before actually calling loadData above.
        },
        endDate (v) {
            this.filters.TimePeriod.endDate = v || null
        },
        startDate (v) {
            this.filters.TimePeriod.startDate = v || null
        },
    },
    components: {
        QDataTableHeader,
        QScoreCardFilters
    }
}
</script>

<style lang="scss" scoped>
.policy-tables {
    $color-bg: #f7f4f4;

    &__col-left {
		flex-basis: 0;
		flex-grow: 1;
		flex-shrink: 1;
		max-width: 100%;
		width: 100%;
		padding: 12px;
		overflow-x: auto;
    }

	&__side {
		height: 100%;
		background-color: $color-bg;
	}
}
</style>
